import Vue from "vue";
import Router from "vue-router";

import Signin from "./views/Signin";
import Scans from "./views/Scans";
import AssetStates from "./views/AssetStates";
import Locations from "./views/Locations";
import Landing from "./views/Landing";
import Settings from "./views/Settings";
import Stations from "./views/Stations";
import Users from "./views/Users";
import Assets from "./views/Assets";
import store from "./store";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/landing",
      component: Landing,
      beforeEnter: requireAuth
    },
    {
      path: "/scan-history",
      component: Scans,
      beforeEnter: requireAdmin
    },
     {
      path: "/locations",
      component: Locations,
      beforeEnter: requireAdmin
    },
    {
      path: "/asset-states",
      component: AssetStates,
      beforeEnter: requireAdmin
    },
    {
      path: "/settings",
      component: Settings,
      beforeEnter: requireAdmin
    },
    {
      path: "/stations",
      component: Stations,
      beforeEnter: requireAdmin
    },
     {
      path: "/assets",
      component: Assets,
      beforeEnter: requireAdmin
    },

    {
      path: "/users",
      component: Users,
      beforeEnter: requireAdmin
    },
    {
      path: "/sign-in",
      component: Signin
    },
    {
      path: "/sign-out",
      beforeEnter(to, from, next) {
        store.dispatch("signOut");
        next("sign-in");
      }
    },
    {
      path: "*",
      redirect: "/landing"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

function requireAdmin(to, from, next) {
  if (store.getters.isAuthenticated && store.getters.isAdmin) {
    next();
  } else {
    next({
      path: "/landing",
      query: { redirect: to.fullPath }
    });
  }
}

function requireAuth(to, from, next) {
  if (store.getters.isAuthenticated) {
    next();
  } else {
    next({
      path: "/sign-in",
      query: { redirect: to.fullPath }
    });
  }
}